<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="12" md="12" align-self="center" style="overflow-x: auto">
        <div :id="idChart" style="min-width: 450px; min-height: 350px"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/export-data";
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: "PermanenceChart",
  props: [
    "location",
    "minDaysForecast",
    "maxDaysForecast",
    "forecasts",
    "flowForecasts",
    "waterAvailability",
    "qoper",
    "q95",
    "q95_50"
  ],
  data: () => ({
    chartRendered: undefined,
    idChart: "permanence-container-chart",
  }),
  methods: {
    chartPreprocessing() {
      const elementId = this.idChart;
      let chart = document.getElementById(elementId);
      let series = [];
      series = [
        this.createDataSerie(
          this.formatChartValuesWaterAvailability(this.waterAvailability, "q1"),
          "Permanência 1 dia",
          "spline",
          "",
          0,
          2,
          "rgba(114, 136, 255, 0.9)"
        ),
        this.createDataSerie(
          this.formatChartValuesWaterAvailability(this.waterAvailability, "q30"),
          "Permanência 30 dias",
          "spline",
          "",
          0,
          2,
          "#A0A0A0"
        ),
        this.createDataSerie(
          this.formatChartPreviousFlowForecastsValues(this.flowForecasts, 2, "flow"),
          "Vazão estimada",
          "line",
          "m³/s",
          1,
          3
        ),
        this.createDataSerie(
          this.formatChartFlowForecastsValues(this.flowForecasts, 2, "flow"),
          "Vazão prevista",
          "line",
          "m³/s",
          1,
          3
        ),
      ];
      if (series) {
        this.charts(elementId, series);
        this.loading = false;
        chart.style.visibility = "visible";
        chart.style.display = "block";
      } else {
        chart.style.visibility = "hidden";
        chart.style.display = "none";
      }

      this.$emit("chartRenderComplete", this.chartRendered);
    },
    async charts(elementId, series) {

      const qoperValue = this.qoper;
      const q95Value = this.q95;
      const q95_50Value = this.q95_50;

      let allX = new Set();
      series.forEach(s => {
        if (s && s.data) {
          s.data.forEach(point => allX.add(point[0]));
        }
      });
      let xValuesArray = Array.from(allX).sort((a, b) => a - b);

      const q95Data = q95Value ? xValuesArray.map(x => [x, q95Value]) : [];
      const q95_50Data = q95_50Value ? xValuesArray.map(x => [x, q95_50Value]) : [];
      const qoperData = qoperValue ? xValuesArray.map(x => [x, qoperValue]) : [];

      Highcharts.setOptions({
        lang: {
          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          shortMonths: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
          weekdays: [
            "Domingo",
            "Segunda",
            "Terça",
            "Quarta",
            "Quinta",
            "Sexta",
            "Sábado",
          ],
        },
      });
      this.chartRendered = Highcharts.chart(elementId, {
        colors: [
          this.$vuetify.theme.themes.dark.secondary.base,
          this.$vuetify.theme.themes.dark.primary.base,
        ],
        colorAxis: {
          gridLineColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        chart: {
          //type: type,
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          height: 600,
          //height: (9 / 16 * 100) + '%' // 16:9 ratio
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
        },
        exporting: {
          enabled: false,
          filename: `Permanência - ${this.location ? this.location.text : ""}`,
          sourceWidth: 1000,

          chartOptions: {
            title: {
              text: `Permanência - ${this.location ? this.location.text : ""}`,
              style: {
                color: "#FFFFFF",
              },
            },
            subtitle: {
              text: `${moment()
                .subtract(this.minDaysForecast, "days")
                .format("DD/MM/YYYY")} até ${moment()
                .add(this.maxDaysForecast, "days")
                .format("DD/MM/YYYY")}`,
              style: {
                color: "#FFFFFF",
              },
            },

            xAxis: {
              tickInterval: 24 * 3600 * 1000,
            },
          },
        },
        title: {
          text: "",
        },
        credits: {
          enabled: true,
          href: "http://www.simepar.br/",
          text: "by: SIMEPAR",
          style: {
            color: "#FFFFFF",
          },
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#FFFFFF",
          },
          itemHoverStyle: {
            color: "#979797",
          },
        },
        xAxis: {
          tickColor: "#2D324F",
          tickWidth: 2,
          lineWidth: 2,
          lineColor: "#2D324F",
          type: "datetime",
          ordinal: false,
          crosshair: {
            enabled: true,
          },
          accessibility: {
            description: `De ${moment()
              .subtract(this.minDaysForecast, "days")
              .format("DD/MM/YYYY")} até ${moment()
              .add(this.maxDaysForecast, "days")
              .format("DD/MM/YYYY")}`,
          },
          //tickInterval: 12* 3600*1000,
          labels: {
            format: "{value:%d/%m}",
            style: {
              color: "#FFFFFF",
            },
          },
          plotLines: [
            {
              value: this.dateToUTC(moment().format("YYYY-MM-DD")),
              //dashStyle: 'dash',
              width: 2,
              color: "white",
              label: {
                text: "Previsão para 7 dias",
                rotation: 0,

                style: {
                  color: "#FFFFFF",
                  fontSize: "12",
                },
              },
              zIndex: 8,
            },
          ],
        },
        yAxis: [
          {
            //tickInterval: 0.5,
            type: "numeric",
            title: {
              text: "% do tempo de vazões superiores a Q",
              style: {
                color: "#FFFFFF",
              },
            },
            accessibility: {
              description: "% do tempo de vazões superiores a Q",
            },
            labels: {
              format: "{value}",
              style: {
                color: "#FFFFFF",
              },
            },
            height: "45%",
            lineWidth: 2,
            lineColor: "#2D324F",
            gridLineWidth: 1,
            gridLineColor: "#2D324F",
            min: 0,
            max: 1,
            resize: {
              enabled: true,
            },
            reversed: true,
            opposite: false,
            plotBands: [
              {
                color: "rgba(255, 114, 120, 0.3)",
                from: 0.95,
                to: 1,
              },
              {
                color: "rgba(252, 210, 125, 0.3)",
                from: 0.75,
                to: 0.95,
              },
              {
                color: "rgba(89, 253, 160, 0.4)",
                from: 0.05,
                to: 0.25,
              },
              {
                color: "rgba(183, 143, 255, 0.5)",
                from: 0,
                to: 0.05,
              },
            ],
          },
          {
            //tickInterval: 1,
            //maxPadding: 2,
            //min: 0,
            lineWidth: 2,
            lineColor: "#2D324F",
            gridLineWidth: 1,
            gridLineColor: "#2D324F",
            //min:Math.min(... series[3].data.map(value => value[1])),
            title: {
              text: "Q- Vazão",
              style: {
                color: "#FFFFFF",
              },
            },
            accessibility: {
              description: "Q- Vazão",
            },
            labels: {
              format: "{value}",
              style: {
                color: "#FFFFFF",
              },
            },
            top: "55%",
            height: "45%",
            offset: 0,
            reversed: false,
            opposite: false,
            min: 0.0,
          },
        ],
        tooltip: {
          //enabled: true,
          shared: true,
          split: true,
          //crosshairs: true,
          useHTML: true,
          xDateFormat: "%A, %b %d",
          pointFormatter: function () {
            const value = this.series.userOptions.valueDecimals
              ? Number(this.y).toFixed(this.series.userOptions.valueDecimals)
              : this.y;
            return (
              '<strong style="color:' +
              this.series.color +
              '">' +
              this.series.name +
              "</strong>: <strong>" +
              value +
              " " +
              this.series.userOptions.valueSuffix +
              "<strong/>"
            );
          },
        },
        series: [
          series[0],
          series[1],
          {
            color: "rgba(255, 114, 120, 0.3)",
            name: "Estiagem",
            dashStyle: "Solid",
            marker: {
              enabled: false,
            },
          },
          {
            color: "rgba(252, 210, 125, 0.3)",
            name: "Rio baixo",
            dashStyle: "Solid",
            marker: {
              enabled: false,
            },
          },
          {
            color: "rgba(89, 253, 160, 0.4)",
            name: "Rio alto",
            dashStyle: "Solid",
            marker: {
              enabled: false,
            },
          },
          {
            color: "rgba(183, 143, 255, 0.5)",
            name: "Cheia",
            dashStyle: "Solid",
            marker: {
              enabled: false,
            },
          },
          {
            name: 'Q95',
            color: '#dbc114',
            dashStyle: 'Dash',
            lineWidth: 1,
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false,
                }
              }
            },
            yAxis: 1,
            data: q95Data,
            showInLegend: !!q95Value,
            valueSuffix: 'm³/s',
            valueDecimals: 3
          },
          {
            name: 'Q95 50%',
            color: '#eb8110',
            dashStyle: 'Dash',
            lineWidth: 1,
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false,
                }
              }
            },
            yAxis: 1,
            data: q95_50Data,
            showInLegend: !!q95_50Value,
            valueSuffix: 'm³/s',
            valueDecimals: 3
          },
          {
            name: 'Q oper',
            color: 'rgb(165, 29, 29)',
            dashStyle: 'Dash',
            lineWidth: 1,
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false,
                }
              }
            },
            yAxis: 1,
            data: qoperData,
            showInLegend: !!qoperValue,
            valueSuffix: 'm³/s',
            valueDecimals: 3
          },
          series[2],
          series[3],
          /*{
                        color: '#72F2E5',
                        name: 'Q95',
                        dashStyle:"dash",
                        marker: {
                            enabled: false
                        },
                    },
                    {
                        color: '#A0A0A0',
                        name: 'Q7,10',
                        dashStyle:"dash",
                        marker: {
                            enabled: false
                        },
                    },
                    {
                        color: '#A0A0A0',
                        name: 'QMLT',
                        dashStyle:"dash",
                        marker: {
                            enabled: false
                        },
                    },
                    {
                        color: '#03A696',
                        name: 'QCaptação',
                        dashStyle:"dash",
                        marker: {
                            enabled: false
                        },

                    },
                    {
                        color: '#C07EEC',
                        name: 'QExtravasamento',
                        dashStyle:"dash",
                        marker: {
                            enabled: false
                        },
                    }*/
        ],
        caption: {
          text: `Gráfico de vazão e permananência de ${moment()
            .subtract(this.minDaysForecast, "days")
            .format("DD/MM/YYYY")} até ${moment()
            .add(this.maxDaysForecast, "days")
            .format("DD/MM/YYYY")}`,
          style: { color: "#FFFFFF" },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      });
    },
    createDataSerie(data, name, type, valueSuffix, yAxis, valueDecimals, color) {
      let serie = { type, name, valueSuffix, yAxis, valueDecimals };
      serie.data = [];
      for (let i in data) {
        let arrayItem = [];
        let x = this.dateToUTC(data[i].date);
        let y = data[i].value;
        arrayItem.push(x);
        arrayItem.push(y);
        serie.data.push(arrayItem);
      }

      if (color) {
        serie.color = color;
      }

      return serie;
    },
    formatChartPreviousFlowForecastsValues(forecasts, sourceid, property) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          const forecast = forecasts[key];
          const { date } = forecast;
          if (moment(date).isSameOrBefore(moment(), "day")) {
            const value =
              forecast.value && forecast.value[0]
                ? forecast.value[0][property]
                : undefined;
            data.push({ value, date });
          }
        }
      }
      return data;
    },
    formatChartFlowForecastsValues(forecasts, sourceid, property) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          const forecast = forecasts[key];
          const { date } = forecast;
          if (moment(date).isSameOrAfter(moment(), "day")) {
            const value =
              forecast.value && forecast.value[0]
                ? forecast.value[0][property]
                : undefined;
            data.push({ value, date });
          }
        }
      }

      return data;
    },
    formatChartValuesWaterAvailability(forecasts, property) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          const { date } = forecasts[key];
          data.push({ value: Number(forecasts[key][property]), date });
        }
      }

      return data;
    },
    dateToUTC(date) {
      const utc = moment(date, "YYYY-MM-DD"); //.locale('en').format('DD/MM');
      return utc.valueOf();
    },
    avarage(array) {
      if (array.length) {
        return array.reduce((a, b) => a + b) / array.length;
      }
      return 0;
    },
  },
};
</script>

<style></style>
